/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Rule_LabelInputs */



/**
* | output |
* | --- |
* | "Trigger alarm when" |
*
* @param {Alarms_Form_Rule_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_form_rule_label = /** @type {((inputs?: Alarms_Form_Rule_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Rule_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Trigger alarm when")
	return /** @type {LocalizedString} */ ("Déclencher l'alarme lorsque")
});